import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from "./store";
import { SessionProvider } from './context/session';
import { ActiveTabProvider } from './context/activeTab';
import { LanguageProvider } from './context/language';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <SessionProvider>
        <ActiveTabProvider>
          <LanguageProvider>
            {/* <React.StrictMode> */}
            <App />
            {/* </React.Stric/tMode> */}
          </LanguageProvider>
        </ActiveTabProvider>

      </SessionProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();